import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Portal } from '@gem/ui-kit';

import { ToastStore } from '../../stores/Toast/ToastStore';
import { ToastType, TToastStyle } from '../../stores/Toast/ToastStore.types';
import styles from './Toast.styles.m.css';

const ANIMATION_TIMEOUT = 300;

const CSSTransitionClasses = {
  enter: styles.toastEnter,
  enterActive: styles.toastEnterActive,
  exit: styles.toastExit,
  exitActive: styles.toastExitActive,
};

const CSSContainerClasses = {
  [ToastType.Global]: styles.containerGlobal,
  [ToastType.Target]: styles.containerTarget,
};

export interface IToastProps {
  isVisible?: boolean;
  className?: string;
  style?: TToastStyle;
}

export const Toast: FC<PropsWithChildren<IToastProps>> = observer((props) => {
  const { className, isVisible, style, children } = props;

  const containerClassName = classNames(
    styles.container,
    className,
    styles[`style-${style || ToastStore.style}`],
    CSSContainerClasses[ToastStore.type]
  );

  return (
    <Portal containerRef={ToastStore.targetRef}>
      <CSSTransition
        in={isVisible || ToastStore.isVisible}
        classNames={CSSTransitionClasses}
        timeout={ANIMATION_TIMEOUT}
        unmountOnExit
      >
        <div className={containerClassName}>{children || ToastStore.content}</div>
      </CSSTransition>
    </Portal>
  );
});
